import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";
import { Logo } from "@/components/landing/Logo";

export default function AuthShell({
  children,
  title,
  subtitle,
  footerText,
  footerHref,
  footerLinkLabel,
  footerVariant = "link",
}) {
  return (
    <div className="relative min-h-screen bg-[#F7F5F2]">
      <div className="grain" />

      {/* Subtle gold accent */}
      <div className="pointer-events-none absolute -right-40 -top-20 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.12),transparent_70%)]" />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-md flex-col justify-center px-6 py-16">
        <Link to="/" className="mb-10 flex items-center gap-3">
          <Logo size={44} />
          <span className="font-serif text-2xl font-semibold tracking-tight text-[#2A2724]">
            Book Away
          </span>
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: EASE }}
        >
          <p className="overline mb-4">{subtitle}</p>
          <h1 className="font-serif text-4xl md:text-5xl font-light leading-[1.05] tracking-tight text-[#2A2724]">
            {title}
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: EASE }}
          className="mt-10"
        >
          {children}
        </motion.div>

        {footerVariant === "button" ? (
          <div className="mt-10 text-center">
            <p className="mb-3 text-sm text-[#6B6B6B]">{footerText}</p>
            <Link
              data-testid="auth-shell-footer-button"
              to={footerHref}
              className="inline-flex w-full items-center justify-center rounded-full bg-gold px-8 py-4 text-base font-semibold text-[#2A2724] shadow-sm transition-colors duration-300 hover:bg-[#AA8627] sm:w-auto sm:min-w-[260px]"
            >
              {footerLinkLabel}
            </Link>
          </div>
        ) : (
          <p className="mt-10 text-sm text-[#6B6B6B]">
            {footerText}{" "}
            <Link
              to={footerHref}
              className="font-medium text-[#2A2724] underline decoration-gold underline-offset-4 hover:text-gold"
            >
              {footerLinkLabel}
            </Link>
          </p>
        )}
      </div>
    </div>
  );
}
